import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'batches',
    lazy: async () => ({ Component: (await import('./BatchesPage')).BatchesPage }),
  },
];
